import '@aws-amplify/ui-react/styles.css';
import awsconfig from 'aws-exports';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
// セッションストレージ用
import { sessionStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { components } from 'pages/login/Compornents';
import { formFields } from 'pages/login/FormFields';
import styled from "@emotion/styled";
import { AppBar, Grid, IconButton, Toolbar, Box, Button, Typography } from "@mui/material"
import LogoutIcon from '@mui/icons-material/Logout';
import { vocabularies } from 'pages/login/Vocablaries';
import React, { useState, createContext } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import TopPage from "./pages/topPage/TopPage";
import FinancialAnalysis from "./pages/financialAnalysis/FinancialAnalysis";
import SearchFinancialRatio from "./pages/searchFinancialRatio/SearchFinancialRatio";
import DisplayFinancialRatio from "./pages/displayFinancialRatio/DisplayFinancialRatio";
import AnalysisResult from "./pages/financialAnalysis/AnalysisResult";
import Error from "./pages/error/Error";
import { HEADER_DISABLED_KEY, SS_CHANGED, getSessionItem } from "./pages/storageCheck/storageCheck";
import logoutBackend from 'shared/logoutBackend';
import sessionCheck from 'shared/sessionCheck';

Amplify.configure(awsconfig);
cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

const BaseAppBar = styled(AppBar)(({ }) => ({
    backgroundColor: '#FFFFFF',
    minHeight: '3rem',
    color: '#000000',
}));

const HeaderGrid = styled(Grid)(({ }) => ({
    textAlign: 'center',
    fontSize: '1rem',
    width: '100%',
    marginTop: '0.3rem'
}));

const WrrapBox = styled(Box)(({ }) => ({
    minWidth: 1000,
    overflowX: 'auto',
    overflowY: 'hidden',
}));

const HeaderButton = styled(Button)(({ }) => ({
    backgroundColor: '#F2F2F2',
    color: '#595959',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '9rem',
    borderRadius: '100rem',
}));

const Footer = styled.footer`
    border-top: 0.1rem solid #000000;
    overflow: auto;
    width: 85%;
    font-size: 1.2rem;
    margin: 0 auto;
    margin-bottom: 2rem;
    padding-top: 0.5rem;
    text-align: center;
`;

// セッションタイムアウトメッセージContext
export const SessionTimeoutMsg = createContext<SessionTimeoutMsg>({} as SessionTimeoutMsg);

// ログイン画面の日本語設定
vocabularies('ja');

function App() {

    // サインアウト処理
    const handleSignOut = async (signOut: any) => {
        // ログアウト(サーバーサイド)
        await logoutBackend();
        // サインアウト(Authenticator)
        signOut();
        // セッションストレージのクリア
        sessionStorage.clear();
        window.history.replaceState("", "", "/Top");
    }

    // セッションタイムアウトメッセージ:非表示
    const [hidden, setHidden] = useState<string>('hidden');
    const sessionTimeoutMsgState = { hidden, setHidden };

    const [disable, setDisable] = useState(
        () => getSessionItem(HEADER_DISABLED_KEY) === "true"
    );

    React.useEffect(() => {
        const handler = (e: Event) => {
            const { key, value } = (e as CustomEvent<{ key: string; value: string }>).detail ?? {};
            if (key === HEADER_DISABLED_KEY) setDisable(value === "true");
        };
        window.addEventListener(SS_CHANGED, handler);
        return () => window.removeEventListener(SS_CHANGED, handler)
    }, []);

    React.useEffect(() => {
        // Update the document title using the browser API
        document.title = 'TSR中小企業経営指標';
    }, []);

    return (
        <SessionTimeoutMsg.Provider value={sessionTimeoutMsgState}>
            <Authenticator.Provider>
                <Authenticator hideSignUp={true} components={components} formFields={formFields}>
                    {({ signOut, user }) => (
                        <div className="flex flex-col min-h-screen overflow-hidden">
                            <WrrapBox>
                                <BaseAppBar position="sticky">
                                    <Toolbar>
                                        <HeaderGrid container spacing={0}>
                                            <Grid size={1}>
                                                <img src={`${process.env.PUBLIC_URL}/symbol-color-min.jpg`} width="50px" onClick={disable ? undefined : () => window.location.href = ("/Top")} style={{ cursor: 'pointer' }} />
                                            </Grid>
                                            <Grid size={6}></Grid>
                                            {disable ? <></> :
                                                <Grid size={5}>
                                                    <Box display='flex' alignItems='center' justifyContent='flex-end' gap={2}>
                                                        <Typography variant='body1'>{user?.signInDetails?.loginId}様</Typography>
                                                        <HeaderButton variant="contained" color="secondary" disabled={disable} aria-label="menu" onClick={() => window.open("https://www.tsr-net.co.jp/static/sme-indicators/help/index.html")}>ヘルプ</HeaderButton>
                                                        <HeaderButton variant="contained" color="secondary" disabled={disable} aria-label="menu" onClick={() => handleSignOut(signOut)}>ログアウト</HeaderButton>
                                                    </Box>
                                                </Grid>
                                            }
                                        </HeaderGrid>
                                    </Toolbar>
                                </BaseAppBar>
                                <BrowserRouter>
                                    <Routes>
                                        <Route path="/" element={<Navigate to="/Top" />} />
                                        <Route path={`/Top`} element={<TopPage />} />
                                        <Route path={`/SearchFinancialRatio`} element={<SearchFinancialRatio />} />
                                        <Route path={`/DisplayFinancialRatio`} element={<DisplayFinancialRatio />} />
                                        <Route path={`/FinancialAnalysis`} element={<FinancialAnalysis />} />
                                        <Route path={`/FinancialAnalysis/Result`} element={<AnalysisResult />} />
                                        <Route path={`/Error`} element={<Error />} />
                                    </Routes>
                                </BrowserRouter>
                                {/** フッター */}
                                <Footer>
                                    &copy; TOKYO SHOKO RESEARCH, LTD.
                                </Footer>
                            </WrrapBox>
                        </div>
                    )}
                </Authenticator>
            </Authenticator.Provider>
        </SessionTimeoutMsg.Provider>
    );
}
export default App;
